module.exports = __webpack_public_path__ + "static/media/image0.c034d8c1.png";